<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20.9" height="20" viewBox="0 0 20.9 20">
    <g transform="translate(-21 -330)">
      <path :style="{stroke:color}" class="a" d="M15,21H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H15" transform="translate(19 328)"/>
      <path :style="{stroke:color}" class="a" d="M18.159,15.113,21,12,15.114,6.014" transform="translate(46.5 320.5) rotate(90)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'AvailableIcon',
  props: {
    color: String
  }
}
</script>

<style scoped>
svg .a {
  fill: none;
  stroke: #fff;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
</style>
